import {apiDomain} from "../config"
import getAPI from "../baseGetAPI";

function getMerchantUserByMidAPI(mid, token, successCallback, failCallback){
    getAPI(`${apiDomain}merchant/${mid}?access_token=${token}`, successCallback, failCallback);
}

export default getMerchantUserByMidAPI;
